import * as t from "io-ts";

// Control Options

export const MediaSizeOptionsV = t.partial({
  imagePropertyPath: t.string,
  disableSrcset: t.boolean
});

export type MediaSizeOptions = t.TypeOf<typeof MediaSizeOptionsV>;

export const MediaOptionsTypeV = t.union([
  t.literal("image"),
  t.literal("video"),
  t.literal("document"),
  t.literal("audio")
]);

export const MediaOptionsV = t.partial({
  multiple: t.boolean,
  acceptedFileTypes: t.array(MediaOptionsTypeV)
});

export type MediaOptions = t.TypeOf<typeof MediaOptionsV>;
export type MediaOptionsType = t.TypeOf<typeof MediaOptionsTypeV>;

// Media

export const SizeV = t.type({
  width: t.number,
  height: t.number,
  orientation: t.string,
  url: t.string
});

// Document, audio, video
export const BaseMediaV = t.type({
  id: t.number,
  filename: t.string,
  url: t.string,
  alt: t.string,
  caption: t.string,
  type: t.string,
  mime: t.string
});

// Images extends the base object
export const ImageV = t.intersection([
  BaseMediaV,
  t.type({
    type: t.literal("image"),
    sizes: t.record(t.string, SizeV),
    attributes: t.record(t.string, t.string)
  })
]);

export const ExternalImageV = t.type({
  id: t.literal(-1),
  type: t.literal("external_image"),
  url: t.string,
  alt: t.string,
  caption: t.string
});

export const MediaV = t.union([BaseMediaV, ImageV, ExternalImageV]);

export const GlobalMediaSizeV = t.type({
  slug: t.string,
  label: t.string,
  subLabel: t.union([t.string, t.undefined]),
  width: t.union([t.number, t.undefined]),
  height: t.union([t.number, t.undefined])
});

export type GlobalMediaSize = t.TypeOf<typeof GlobalMediaSizeV>;

export type Size = t.TypeOf<typeof SizeV>;
export type Media = t.TypeOf<typeof MediaV>;
export type Image = t.TypeOf<typeof ImageV>;
export type ExternalImage = t.TypeOf<typeof ExternalImageV>;

// WPMediaInput can either handle single images or array of images (gallery mode)
export type MediaInputValue = Media | Media[];
